import { useImmer } from "use-immer";
import { useEffect } from "react";
import _ from "lodash-contrib";
import ReportPageTransactionTableHeader from "./TransactionTableHeaderValueReportPage";
import TransactionTableRowColumnReportPage from "./TransactionTableRowColumnReportPage";
import { useLocation } from "react-router-dom";
import LocationService from "../../service/RouteUtilService";

const Component = ({ transactions, displayedTransactionAttributes }) => {
  const [rows, updateRows] = useImmer([]);
  const [highlightTransactionIds, updateHighlightTransactionIds] = useImmer([]);
  const location = useLocation();

  useEffect(async () => {
    updateHighlightTransactionIds(
      LocationService.getParamNumberArray(
        location,
        "highlightTransactionIds",
        [],
      ),
    );
  }, [location]);

  useEffect(() => {
    let tmpRows = [];
    for (let transaction of transactions) {
      let tmpRow = {};

      for (let attributeList of displayedTransactionAttributes) {
        const value = _.get(transaction, attributeList);
        _.set(tmpRow, attributeList, value);
      }

      tmpRows.push(tmpRow);
    }

    updateRows(tmpRows);
  }, [transactions, displayedTransactionAttributes]);

  return (
    <>
      <table className="config-table-double table-scrollable">
        <thead>
          <tr>
            {displayedTransactionAttributes.map((attributeArr, idx) => (
              <th key={idx}>
                <ReportPageTransactionTableHeader
                  headerNameArr={attributeArr}
                ></ReportPageTransactionTableHeader>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((transaction, idx) => (
            <tr
              key={idx}
              className={
                highlightTransactionIds.includes(transaction.id) ? "warn" : ""
              }
            >
              {displayedTransactionAttributes.map((attributeName, idx1) => (
                <td key={idx1} className="use-mono-font">
                  <TransactionTableRowColumnReportPage
                    value={_.get(transaction, attributeName)}
                    attributeName={attributeName}
                    transaction={transaction}
                  ></TransactionTableRowColumnReportPage>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
